import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import WorksStaffPaymentRatesNormsDt from '@/services/dataTransferModules/worksStaffPaymentRatesNormsDt'

const worksStaffPaymentRatesNormsDt = new WorksStaffPaymentRatesNormsDt()

export default function useWorksStaffPaymentRatesNorms() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: worksStaffPaymentRatesNorms,
		getEntities: getWorksStaffPaymentRatesNorms,

		entity: worksStaffPaymentRatesNorm,
		getEntity: getWorksStaffPaymentRatesNorm,

		createEntity: createWorksStaffPaymentRatesNorm,
		updateEntity: putWorksStaffPaymentRatesNorm,
		patchEntity: updateWorksStaffPaymentRatesNorms,
		deleteEntity: deleteWorksStaffPaymentRatesNorm,
	} = useBlProviders(worksStaffPaymentRatesNormsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Download error of salaries rates'),

		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Pay rate loading error'),

		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error creating works staff payment rates norm'),

		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Pay rate editing error'),

		showErrorNotificationForDeletingEntity: true,
		errorNotificationTextForDeletingEntity: $t('Error when deleting salary rates'),
	})

	const defaults = {
		creatingWorksStaffPaymentRatesNorm: {
			name: '',
			metric: '',
			optimal_value: '',
			min_value: '',
			max_value: '',
			koef: '',
			work: '',
			role: '',
		},
		fieldsToPatch: [
			'name',
			'metric',
			'optimal_value',
			'min_value',
			'max_value',
			'koef',
			'work',
			'role',
		],
	}

	return {
		flags,
		defaults,
		worksStaffPaymentRatesNorms,
		worksStaffPaymentRatesNorm,
		getWorksStaffPaymentRatesNorms,
		getWorksStaffPaymentRatesNorm,
		createWorksStaffPaymentRatesNorm,
		putWorksStaffPaymentRatesNorm,
		updateWorksStaffPaymentRatesNorms,
		deleteWorksStaffPaymentRatesNorm,
	}
}
